import React, { useState, useEffect, useContext } from "react";
import { getAuth, onAuthStateChanged } from '@firebase/auth'
import { doc, onSnapshot } from "firebase/firestore";

import {FirebaseContext} from '../Firebase/Context'

const AuthContext = React.createContext(null);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState()
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)
  const { db } = useContext(FirebaseContext)

  const setErrorO = (e) => {
    console.error(e)
    setError(e)
  }
  useEffect(() => {
    setLoading(true)
    let profileSub = null
    let orgSub = null
    const unsubscribe = onAuthStateChanged(getAuth(), (user) => {
      if (!user) {
        setLoading(false)
        setUser(null)
        if(profileSub) {
          profileSub()
        }
        if(orgSub) {
          orgSub()
        }
        return 
      }
      profileSub = onSnapshot(doc(db, "users", user.uid), (profile) => {
        const userProfile = profile.data()
        orgSub = onSnapshot(doc(db, "organisations", userProfile.organisationId), (org) => {
          setLoading(false)
          setUser({...user, ...userProfile, organisation: org.data()})
        }, setErrorO);
      }, setErrorO);
    }
    , setErrorO)
    return () => {
      unsubscribe()
      if(profileSub) {
        profileSub()
      }
      if(orgSub) {
        orgSub()
      }
    }
  }, [db])
  return <AuthContext.Provider value={{ user, error, loading }}>{children}</AuthContext.Provider>
}

export { AuthProvider, AuthContext }
